import Vue from 'vue'
import { settings } from './variables.js'
import axios from 'axios'

import ContactForm from './vue_components/ContactForm.vue'
import QuestionForm from './vue_components/QuestionForm.vue'
import StreamInvite from './vue_components/StreamInvite.vue'
import StreamCountdown from './vue_components/StreamCountdown.vue'


Vue.config.productionTip = false
axios.defaults.baseURL = settings.apiBaseUrl
axios.defaults.withCredentials = true 
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

Vue.prototype.$axios=axios

const moment = require('moment')
require('moment/locale/ru')

Vue.use(require('vue-moment'), {
  moment
})


var vm = new Vue({
  el: '#app',
  components: {
  	'contactform': ContactForm,
    'questionform': QuestionForm,
    'stream-invite': StreamInvite,
    'stream-countdown': StreamCountdown
  },
  data: {}
})
